import styled from "styled-components/macro";
import { Modal, Button } from "antd";

import { typography } from "src/utils/styledComponents/typography";
import { colors } from "src/theme/colors";

export const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-footer {
      display: flex;

      .ant-btn + .ant-btn {
        margin-left: 0;
      }
    }
    ${typography.CustomText("1em")}
    .ant-modal-body {
      padding: 10px;
      padding-top: 0px;
    }
    .ant-modal-header {
      border-bottom: 0px;
      .ant-modal-title {
        text-align: center;
      }
    }
  }
`;

export const StyledButton = styled(Button)`
  &.ant-btn {
    border-radius: 5px;
    height: 48px;

    &.ant-btn-dangerous {
      color: ${colors.error[600]};
      background: #fff;
      border-color: ${colors.error[600]};

      &:hover,
      &:focus {
        color: white;
        background: ${colors.error[600]};
        border-color: ${colors.error[400]};
      }
    }

    &.ant-btn-primary {
      background-color: ${colors.primary[500]};
    }
  }
`;

export const Title = styled.span`
  ${typography.CustomText("18px")}
  font-weight: 600;
  letter-spacing: -0.015em;
  color: ${colors.gray[900]};
`;

export const SubTitle = styled.span`
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  /* opacity 0.5 dims the glyphs rather than colouring them. */
  color: ${colors.gray[600]};
`;

export const Frame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 8px 4px;
`;
